export default __webpack_public_path__ + "static/media/BDD-scenarios.d0480f9d.jpg";